export default {
  '0': {
    name: 'Punch',
    power: 0.15,
    effect: '0',
    element: '0',
    accuracy: 1,
    description: ''
  },
  '1': {
    name: 'Kick',
    power: 0.35,
    effect: '0',
    element: '0',
    accuracy: 0.9,
    description: ''
  },
  '2': {
    name: 'Slap',
    power: 0.25,
    effect: '0',
    element: '1',
    accuracy: 1,
    description: ''
  }
}
